import React from 'react';
import PropTypes from 'prop-types';
import Label from "../../common/primitives/Label";
import Price, {ConvertToEUR} from "../../common/primitives/Price";

import styles from './CartLines.scss';

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from "./img/remove.png";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLineSEO = ({data, removeService, showAsPage, useServiceName}) => {
	let {
		id,
		serviceName,
		serviceTypeName,
		serviceId,
		currency,
		priceOrig,
		priceTopOrig,
		canDelete,
		loading
	} = data;

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	if (priceTopOrig === priceOrig) {
		priceTopOrig = '';
	}
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={`${useServiceName ? serviceName : serviceTypeName}`}
					className={`${helpers.orderServiceName} ${!showAsPage ? `${styles.additionalServiceLabel} ${styles.asPageServiceName}` : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '12@md' : ''}`}>
				  <div className={styles.additionalServicePrice}>
					  <table>
						  <tbody>
						  <tr>
							  <td>
								  {__t('еднократно')}
							  </td>
							  <td className={styles.oldPrice} data-layout='text-right'>
								  {priceTopOrig}
								  {SHVO.showEuroPrices && <>
									  <br/>
									  {ConvertToEUR(priceTopOrig)}
								  </>}
							  </td>
							  <td data-layout="text-right" className={styles.priceContainer}>
								  <Price currency={currency} value={priceOrig} currencyClass={styles.currencyHolder}/>
								  {SHVO.showEuroPrices && <>
									  <br/>
									  <Price currency={'EUR'} value={ConvertToEUR(priceOrig)} currencyClass={styles.currencyHolder}/>
								  </>}
							  </td>
							  <td style={showAsPage && {width: '0'}}/>
						  </tr>
						  </tbody>
					  </table>

				  </div>
			  </div>
		  </div>
	  </section>
	);

};

CartLineSEO.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		currency: PropTypes.string.isRequired,
		priceOrig: PropTypes.string.isRequired,
		priceTopOrig: PropTypes.string.isRequired,
		canDelete: PropTypes.bool,
	}),
	removeService: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool,
	useServiceName: PropTypes.bool
};

export default CartLineSEO;